const API_URL = process.env.REFERRAL_URL || process.env.REACT_APP_REFERRAL_URL || "https://referral-service.centivo.dev/";
const API_ACCESS_TOKEN = process.env.REFERRAL_SERVICE_ACCESS_TOKEN || process.env.REACT_APP_REFERRAL_SERVICE_ACCESS_TOKEN;
const Axios = require('axios').default;
const https = require('https');
const httpsAgent = new https.Agent({ keepAlive: true });
const axios = Axios.create({
    timeout: process.env.AXIOS_TIMEOUT_OVERRIDE || 30000,
    httpsAgent
});
if (API_ACCESS_TOKEN == null) {
    // throw Error("Missing access token for referral service.")
    console.log("Missing access token for referral service.");
}

const handle404Error = (e) => {
    try {
        if (e.response.status.toString() === "404") {
            return [];
        }
    } catch (e2) {
        console.log("ORIGINAL ERROR THROWING CATCH ERROR:", e);
        throw (e2);
    }
}

const getReferralsById = async (referralUuid) => {
    let response = null;
    try {
        response = await axios.get(`${API_URL}getReferralsById`, {
            headers: {
                'content-type': 'application/json',
                'Authorization': API_ACCESS_TOKEN
            },
            params: {
                referralUuid: referralUuid
            }
        });
        if (response.status !== 200) {
            return null;
        }
        return response.data;
    } catch (e) {
        return handle404Error(e);
    }
}

const getReferralsByPatientId = async (patientUuid, dateFrom, dateTo, lastEvalKey, usePagination) => {
    let response = null;
    try {
        response = await axios.get(`${API_URL}getReferralsByPatientId`, {
            headers: {
                'content-type': 'application/json',
                'Authorization': API_ACCESS_TOKEN
            },
            params: {
                patientUuid: patientUuid,
                dateFrom: dateFrom,
                dateTo: dateTo,
                lastEvalKey,
                usePagination
            }
        });
        if (response.status !== 200) {
            return null;
        }
        return response.data;
    } catch (e) {
        return handle404Error(e);
    }
}

const getReferralsByProviderUserEmail = async (email) => {
    let response = null;
    try {
        response = await axios.get(`${API_URL}getReferralsByProviderUserEmail`, {
            headers: {
                'content-type': 'application/json',
                'Authorization': API_ACCESS_TOKEN
            },
            params: {
                email: email
            }
        });
        if (response.status !== 200) {
            return null;
        }
        return response.data;
    } catch (e) {
        return handle404Error(e);
    }
}

const getReferralsByReferredByTinPagination = async (tin, dateFrom, dateTo, paginate = true, lastEvalKey = null) => {
    let response = null;
    try {
        response = await axios.get(`${API_URL}getReferralsByReferredByTinPagination`, {
            headers: {
                'content-type': 'application/json',
                'Authorization': API_ACCESS_TOKEN
            },
            params: {
                tin: tin,
                dateFrom: dateFrom,
                dateTo: dateTo,
                paginate: paginate,
                lastEvalKey: lastEvalKey
            }
        });
        if (response.status !== 200) {
            return null;
        }
        return response.data;
    } catch (e) {
        return handle404Error(e);
    }
}

const getReferralsByReferredByTin = async (tin, dateFrom, dateTo) => {
    let response = null;
    try {
        response = await axios.get(`${API_URL}getReferralsByReferredByTin`, {
            headers: {
                'content-type': 'application/json',
                'Authorization': API_ACCESS_TOKEN
            },
            params: {
                tin: tin,
                dateFrom: dateFrom,
                dateTo: dateTo
            }
        });
        if (response.status !== 200) {
            return null;
        }
        return response.data;
    } catch (e) {
        return handle404Error(e);
    }
}

const getReferralsByReferredToTinPagination = async (tin, dateFrom, dateTo, paginate = true, lastEvalKey = null) => {
    let response = null;
    try {
        response = await axios.get(`${API_URL}getReferralsByReferredToTinPagination`, {
            headers: {
                'content-type': 'application/json',
                'Authorization': API_ACCESS_TOKEN
            },
            params: {
                tin: tin,
                dateFrom: dateFrom,
                dateTo: dateTo,
                paginate: paginate,
                lastEvalKey: lastEvalKey
            }
        });
        if (response.status !== 200) {
            return null;
        }
        return response.data;
    } catch (e) {
        return handle404Error(e);
    }
}

const getReferralsByReferredToTin = async (tin, dateFrom, dateTo) => {
    let response = null;
    try {
        response = await axios.get(`${API_URL}getReferralsByReferredToTin`, {
            headers: {
                'content-type': 'application/json',
                'Authorization': API_ACCESS_TOKEN
            },
            params: {
                tin: tin,
                dateFrom: dateFrom,
                dateTo: dateTo
            }
        });
        if (response.status !== 200) {
            return null;
        }
        return response.data;
    } catch (e) {
        return handle404Error(e);
    }
}

/**
 * @param {*} referral 
 * @param {*} member 
 * @param {*} referredByCarepoint 
 * @param {*} referredToCarepoint 
 * @param {*} secondaryReferredToCarepointsList 
 */
const submitReferral = async (referral, member, referredByCarepoint, referredToCarepoint, secondaryReferredToCarepointsList) => {
    try {
        const response = await axios.post(`${API_URL}submitReferral`, {
            referral: referral,
            member: member,
            referredByCarepoint: referredByCarepoint,
            referredToCarepoint: referredToCarepoint,
            secondaryReferredToCarepointsList: secondaryReferredToCarepointsList
        }, {
            headers: {
                'content-type': 'application/json',
                'Authorization': API_ACCESS_TOKEN
            }
        });
        if (response.status !== 200) {
            return null;
        }
        return response.data;
    } catch (e) {
        throw e;
    }
}

/**
 * 
 * @param {string} referralUuid 
 * @param {string} referralReason 
*  @param {number} referralDurationDays
 * @returns 
 */
const extendReferral = async (referralUuid, referralReason, referralDurationDays = undefined) => {
    try {
        const response = await axios.post(`${API_URL}extendReferral`, {
            referralUuid,
            referralReason,
            referralDurationDays,
        }, {
            headers: {
                'content-type': 'application/json',
                'Authorization': API_ACCESS_TOKEN
            }
        });
        if (response.status !== 200) {
            return null;
        }
        return response.data;
    } catch (e) {
        throw e;
    }
}

/**
 * @param {*} referralUuid 
 * @param {*} expirationDate 
 */
const updateReferralExpiration = async (referralUuid, expirationDate) => {
    try {
        const response = await axios.put(`${API_URL}updateReferralExpiration`, {
            referralUuid: referralUuid,
            expirationDate: expirationDate
        }, {
            headers: {
                'content-type': 'application/json',
                'Authorization': API_ACCESS_TOKEN
            }
        });
        if (response.status !== 200) {
            return null;
        }
        return response.data;
    } catch (e) {
        throw e;
    }
}

module.exports = {
    getReferralsById,
    getReferralsByPatientId,
    getReferralsByProviderUserEmail,
    getReferralsByReferredByTinPagination,
    getReferralsByReferredByTin,
    getReferralsByReferredToTinPagination,
    getReferralsByReferredToTin,
    submitReferral,
    extendReferral,
    updateReferralExpiration
}